import { TreeViewResponseItem } from "@/apis/preview/v2/types";
import { TagDetailPopoverContent } from "@/components/mapping/retrieval-results/tag-detail-popover";
import { destructTagKey } from "@/components/mapping/utils";
import { Popover, PopoverAnchor, PopoverContent } from "@/styles/ui/popover";
import { TagType } from "@/types/mapping";
import { ReactNode } from "react";

/**
 * 태그 빌딩 트리 행에 [매핑] 목록과 같은 "태그 상세정보" 팝오버를 붙인다.
 * 열림 상태는 행이 hover 로 제어한다 — 이 컴포넌트는 표시만 담당한다.
 */
export const TreeTagDetailPopover = ({
  item,
  roleKey,
  open,
  onOpenChange,
  onContentHoverChange,
  children,
}: {
  item: TreeViewResponseItem;
  roleKey: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContentHoverChange: (hovering: boolean) => void;
  children: ReactNode;
}) => {
  const { prefix, name = item.tagKey } = destructTagKey(item.tagKey);

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent
        side="left"
        align="start"
        sideOffset={20}
        className="w-[320px] flex flex-col items-start rounded-xl shadow-2xl p-0"
        // 시트 선택·키보드 입력을 가로채지 않게 포커스를 옮기지 않는다.
        onOpenAutoFocus={(e) => e.preventDefault()}
        onMouseEnter={() => onContentHoverChange(true)}
        onMouseLeave={() => onContentHoverChange(false)}
      >
        <TagDetailPopoverContent
          prefix={prefix}
          name={name}
          label={item.tagKoLabel}
          type={item.tagType as TagType}
          description={null}
          roleKey={roleKey}
        />
      </PopoverContent>
    </Popover>
  );
};
